module.exports = __webpack_public_path__ + "assets/images/premium-features/salaries-preview-d380bf.svg";